import $fn from '@/utils/fn.ts';
import httpApi from '@/apis/httpApi'
import http from "@/utils/http.js"

// 获取全部游戏
interface AllGameJson {
  client_type: number,
  char: string,
  keyword: string,
  version_id: number,
  tag_id: number,
}
export const AllGameList = (json: AllGameJson): any => http.httpGet({
	url: httpApi.game.AllGame,
	json,
})

// 获取最近在玩
export const userGameList = (): any => http.httpGet({
	url: httpApi.game.userGame,
})

// 获取版本与特色
interface AllVersionAndTagJson {
	token: string,
}
export const AllVersionAndTagList = (json: AllVersionAndTagJson): any => http.httpPost({
	url: httpApi.game.AllVersionAndTag,
	json,
})

// 获取角色列表
interface ListJson {
	server_id: string
}
export const list = (json: ListJson): any => http.httpGet({
	url: httpApi.game.list,
	json
})

